$(document).ready(function () {
  const blockedEmails = ["team@discourse.org", "support@discourse.org"];

  $.validator.addMethod(
    "subdomainValidator",
    function (value) {
      const s = value.trim().toLowerCase();
      return (
        s.match(/^(?=^[a-z0-9])(?=[a-z0-9\-].{1,49}$)[a-z0-9\-]+[a-z0-9]+$/) &&
        s.match(/[a-z]/)
      );
    },
    "Please enter a valid subdomain."
  );

  $.validator.addMethod(
    "emailValidDomain",
    function (value) {
      const s = value.trim().toLowerCase();
      return s.match(
        /[a-zA-Z0-9!#\$%&'*+\/=?\^_`{|}~\-]+(?:\.[a-zA-Z0-9!#\$%&'\*+\/=?\^_`{|}~\-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}(?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/
      );
    },
    "Please enter a valid email address."
  );

  $.validator.addMethod(
    "emailBlocklistValidator",
    function (value) {
      const s = value.trim().toLowerCase();
      return !s.endsWith("teams.discourse.com") && !blockedEmails.includes(s);
    },
    "You can't use that email address."
  );

  // Enterprise rejects anyone trying to use gmail.com, including appending strings
  $.validator.addMethod(
    "enterpriseWorkplaceEmailValidator",
    function (value) {
      const s = value.trim().toLowerCase();
      return !(s.indexOf("gmail.com") > 0);
    },
    "Please use an email address with your organization's domain."
  );

  const $signupForm = $("#signup-form"),
    $enterpriseForm = $("#enterprise-form"),
    $subdomainField = $("#subdomain"),
    $domainField = $("#domain"),
    $domainWarning = $("#domain-input-warning"),
    $discourseGroupInputs = $("#discourse-group-inputs"),
    $customDomainMessage = $("#custom-domain-message .message"),
    $legalAgreementCheckbox = $("#legal-agreement"),
    $emailOptInCheckbox = $("#email-opt-in"),
    $emailField = $("#email"),
    $nameField = $("#contact_name"),
    $addCouponCode = $("#add-coupon-code"),
    $addReferralCode = $("#add-referral-code"),
    $chooseServerLocation = $("#choose-server-location"),
    $signupStepNumber = $("#step-number"),
    $signupButton = $("#submit-confirm"),
    $formBody = $("#form-body"),
    $pleaseWait = $("#form-please-wait"),
    $emailToConfirm = $("#email-to-confirm");

  let callScheduled = false;

  let signupStep = "step_email";
  let identifier = "";
  let data = {};
  let StepEmailSubmitting = false;

  const urlParams = new URLSearchParams(window.location.search);
  const page = urlParams.get("p") ?? "pricing";
  const language = urlParams.get("l") ?? "en";
  const page_tier = $signupForm.data("form-id");

  let formStartTime = 0;

  $subdomainField.val("");
  $domainWarning.hide();
  $discourseGroupInputs.show();

  $("a", $addCouponCode).on("click", function (e) {
    e.preventDefault();
    showHideField(".coupon-code-fields");
    return false;
  });

  $("a", $addReferralCode).on("click", function (e) {
    e.preventDefault();
    showHideField(".referral-code-fields");
    return false;
  });

  $("a", $chooseServerLocation).on("click", function (e) {
    e.preventDefault();
    showHideField(".server-location-fields");
    return false;
  });

  function showHideField(field) {
    if ($(field).css("display") === "none") {
      $(field).css("display", "flex");
    } else {
      $(field).css("display", "none");
    }
  }

  if ($signupForm.length) {
    launchForm($signupForm.data("form-id"));
    $emailField.focus();
  } else {
    $nameField.focus();
  }

  // Sets up the signup form
  function launchForm(formId) {
    $("#tier_selected").val(formId === "pro" ? "standard" : formId);

    const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
    $(cookies).each((cookie) => {
      const [name, value] = cookies[cookie].split("=");
      if (name === "referral_code") {
        $("input[name=referral_code]", $signupForm).val(value);
        showHideField(".referral-code-fields");
      }

      if (name === "coupon_code") {
        $("input[name=coupon_code]", $signupForm).val(value);
        showHideField(".coupon-code-fields");
      }

      if (name === "coupon_code" && value.startsWith("GETSTARTED")) {
        $("#coupon-code-legal")
          .html(`<p>Coupon code <b>${value}</b> gets you one month free on your subscription to start building your community.
          To explore plan features, visit our <a href="/pricing" target="_blank">pricing&nbsp;page</a>.</p>`);
      }
    });

    if (formId === "basic" || formId === "starter") {
      $customDomainMessage.html(
        "You can upgrade any time to set up your own domain!"
      );
    } else {
      $customDomainMessage.html(
        "You can change this to your own domain later!"
      );
    }
    $("#error-notice").html("").hide();
    $("#buy-form-data").show();

    // This one's self-serve only
    $legalAgreementCheckbox.prop("checked", false);
  }

  // These are common to both forms
  $emailOptInCheckbox.prop("checked", false);
  formStartTime = performance.now();

  function goBack() {
    // This is the opposite of what we do in the step 1 form response below.
    $(".step_plan").addClass("step_email_ignore");
    $("#subdomain").rules("remove");

    if ($errorNotice) {
      $errorNotice.html("");
      $errorNotice.hide();
    }

    $signupStepNumber.html(1);
    $signupButton.html("Continue");
    $(".create-account-header").show();
    $(".fields-email").show();
    $(".fields-plan").hide();
    $(".fields-email-to-confirm").hide();
    $("#form-field-email-opt-in").show();
    $("#form-field-legal-agreement").hide();
    $("#signup-withdraw").css("display", "none");
    signupStep = "step_email";

    // eslint-disable-next-line no-undef
    plausible("Signup Go Back Button Click", {
      props: { context: "signup_step_plan", page: `signup_${page_tier}` },
    });
  }

  $("#link-go-back").on("click", function (e) {
    e.preventDefault();
    goBack();
    return false;
  });

  $("#signup-withdraw").on("click", function () {
    goBack();
  });

  const $errorNotice = $("#error-notice");

  // Skip subdomain validator in the initial form submit,
  //  add it when we get a success response and move to step 2
  $signupForm.validate({
    ignore: ".step_email_ignore",
    rules: {
      email: {
        required: true,
        email: true,
        emailBlocklistValidator: true,
        emailValidDomain: true,
      },
    },
    groups: {
      domainInputs: "subdomain",
    },
    errorPlacement: function (error, element) {
      if (element.attr("name") === "subdomain") {
        error.insertAfter("#discourse-group-inputs");
      } else {
        error.insertAfter(element);
      }
    },
  });

  // Common form for starter, standard/pro, business ==========================
  const submitSignupForm = function (extraData) {
    if (StepEmailSubmitting) {
      return false;
    }

    if (signupStep === "step_email") {
      StepEmailSubmitting = true;
      $signupButton.addClass("disabled-button");
      // eslint-disable-next-line no-undef
      plausible("Signup Continue Button Submit", {
        props: { context: "signup_step_email", page: `signup_${page_tier}` },
      });
    }

    if (signupStep === "step_plan") {
      // eslint-disable-next-line no-undef
      plausible("Signup Start Trial Button Submit", {
        props: { context: "signup_step_plan", page: `signup_${page_tier}` },
      });
    }

    if (signupStep === "step_payment") {
      $formBody.hide();
      $pleaseWait.show();
    }

    const tier = $("#tier_selected").val();

    // Set up step 1 data to submit
    data = {
      company_name: $("input[name=company_name]", $signupForm).val(),
      email: $("input[name=email]", $signupForm).val(),
      tier_selected: tier,
      email_opt_in: $emailOptInCheckbox.is(":checked"),
      legal_agreed: false,
      terms: $("input[name=terms]", $signupForm).val(),
      signup_step: "step_email",
      identifier,
    };

    if (signupStep === "step_plan" || signupStep === "step_payment") {
      $domainField.val($subdomainField.val() + ".discourse.group");

      // Collect and merge the step 2 data
      let data2 = {
        community_name: $("input[name=community_name]", $signupForm).val(),
        domain: $("input[name=domain]", $signupForm).val(),
        subdomain: $subdomainField.val(),
        region: $("input[name=region_name]:checked", $signupForm).val(),
        coupon_code: $("input[name=coupon_code]", $signupForm).val(),
        referral_code: $("input[name=referral_code]", $signupForm).val(),
        legal_agreed: $legalAgreementCheckbox.is(":checked"),
        signup_step: signupStep,
      };
      data = { ...data, ...data2 };
    }

    if (extraData) {
      data = { ...data, ...extraData };
    }

    $.ajax({
      url: window.BUY_API_URL,
      type: "POST",
      dataType: "json",
      data,
    })
      .done(function (response) {
        StepEmailSubmitting = false;
        $signupButton.removeClass("disabled-button");

        if (response.success) {
          if (response.identifier) {
            if (signupStep === "step_email") {
              signupStep = "step_plan";
              identifier = response.identifier;

              $(".step_email_ignore").removeClass("step_email_ignore");
              $("#subdomain").rules("add", {
                required: true,
                subdomainValidator: true,
              });

              $emailToConfirm.html($("input[name=email]", $signupForm).val());
              $signupStepNumber.html(2);
              $signupButton.html("Start your 14-day trial!");

              $(".create-account-header").hide();
              $(".fields-email").hide();
              $(".fields-plan").show();
              $(".fields-email-to-confirm").show();
              $("#form-field-email-opt-in").hide();
              $("#form-field-legal-agreement").show();
              $("#signup-withdraw").css("display", "flex");
              $("#buy-form-data").show();
            } else {
              // Plausible conversion event tracking is defined globally in <head/>
              // eslint-disable-next-line no-undef
              plausible("Conversion", { props: { tier, page, language } });

              // GTM tracking is defined globally in <head/>
              // eslint-disable-next-line no-undef
              dataLayer.push({
                event: "selfServeSignup",
                signupData: {
                  tier,
                  page,
                  language,
                },
              });

              if (response.redirect_url) {
                window.location.href = response.redirect_url;
              } else {
                $("#form-body").hide();
                $("#confirmation-email").html(
                  $("input[name=email]", $signupForm).val()
                );
                $("#confirmation-message").show();
              }
            }
          } else {
            $errorNotice.html(
              "Sorry, there was an error. Try again or send an email to <a href='mailto:team@discourse.org'>team@discourse.org</a>."
            );
            $errorNotice.show();
            $formBody.show();
            $pleaseWait.hide();
          }
        } else {
          identifier = response.identifier;
          if (signupStep === "step_payment") {
            const displayError = document.getElementById("card-errors");
            if (response.messages) {
              displayError.textContent = response.messages.join("<br/>");
            } else if (response.message) {
              displayError.textContent = response.message;
            } else {
              displayError.textContent = "";
            }
          } else {
            $("#buy-form-data").show();
            if (response.failed === -32) {
              $domainWarning.html(response.messages.join("<br/>"));
              $domainWarning.show();
            } else {
              $errorNotice.html(response.messages.join("<br/>"));
              $errorNotice.show();
            }
          }
          $formBody.show();
          $pleaseWait.hide();
        }
      })
      .fail(function (xhr) {
        $("#buy-form-data").show();
        if (xhr.status === 429) {
          $errorNotice.html(
            "Too many requests. Please wait and try again later."
          );
        } else {
          $errorNotice.html(
            "Sorry, something went wrong. Try again or send an email to <a href='mailto:team@discourse.org'>team@discourse.org</a>."
          );
        }
        $errorNotice.show();
        $formBody.show();
        $pleaseWait.hide();
      });
    // $.ajax end
  };

  $signupForm.on("submit", function (e) {
    let formSubmitTime = performance.now();

    if (formStartTime === 0 || formSubmitTime - formStartTime < 1000) {
      /* Too fast. Slow down, bots. */
    } else if ($signupForm.valid()) {
      // Handle submits for both steps
      if (signupStep === "step_plan") {
        if (!$legalAgreementCheckbox.is(":checked")) {
          $("#buy-form-data").show();
          $errorNotice.html(
            "You must agree to the Discourse Free Trial Terms."
          );
          $errorNotice.show();
          e.preventDefault();
          return false;
        }
      }

      if ($errorNotice) {
        $errorNotice.html("");
        $errorNotice.hide();
      }

      submitSignupForm();
    }
    e.preventDefault();
    return false;
  });

  // Enterprise form ====================================================
  const $currentForumInput = $("#current_forum"),
    $wantToMigrateInput = $("#want_to_migrate"),
    $wantToMigrateFields = $("#want-to-migrate-fields"),
    $enterpriseSubmit = $("#submit-enterprise-final", $enterpriseForm);

  $enterpriseForm.validate({
    ignore: ":hidden",
    rules: {
      email: {
        required: true,
        email: true,
        emailBlocklistValidator: true,
        enterpriseWorkplaceEmailValidator: true,
      },
      company_size: {
        required: true,
      },
      enterprise_comments: {
        required: true,
      },
    },
    errorPlacement: function (error, element) {
      error.insertAfter(element);
    },
  });

  $currentForumInput.on("change", function () {
    if ($currentForumInput.val() === "none") {
      $(".has-current-forum", $enterpriseForm).slideUp();
    } else {
      $wantToMigrateFields.slideDown();
      $wantToMigrateInput.change();
    }
  });

  $wantToMigrateInput.on("change", function () {
    $wantToMigrateInput.val() === "true"
      ? $(".wants-to-migrate", $enterpriseForm).slideDown()
      : $(".wants-to-migrate", $enterpriseForm).slideUp();
  });

  $currentForumInput.change();

  let formSubmitted = false;

  $enterpriseForm.on("submit", function (e) {
    const tier = $("#tier_selected").val();
    if (!formSubmitted && $enterpriseForm.valid()) {
      $enterpriseSubmit.addClass("invisible");
      formSubmitted = true;

      if ($errorNotice) {
        $errorNotice.html("");
        $errorNotice.hide();
      }

      const enterpriseFormData = {
        call_scheduled: callScheduled,
        email_opt_in: $emailOptInCheckbox.is(":checked"),
      };

      $.each($enterpriseForm.serializeArray(), function (i, field) {
        if (field.name !== "email-opt-in") {
          enterpriseFormData[field.name] = field.value;
        }
      });

      $.ajax({
        url: window.BUY_API_URL,
        type: "POST",
        dataType: "json",
        data: enterpriseFormData,
      })
        .done(function (response) {
          if (response.success) {
            window.location.href = `/confirm?tier=e&page=${page}&language=${language}`;
            // Plausible conversion event tracking is defined globally in <head/>
            // eslint-disable-next-line no-undef
            plausible("Conversion", { props: { tier, page, language } });
          } else {
            $errorNotice.html(response.messages.join("<br/>"));
            $errorNotice.show();
          }
        })
        .fail(function (xhr) {
          if (xhr.status === 429) {
            $errorNotice.html(
              "Too many requests. Please wait and try again later."
            );
          } else {
            $errorNotice.html(
              "Sorry, something went wrong. Try again or send an email to <a href='mailto:team@discourse.org'>team@discourse.org</a>."
            );
          }
          $errorNotice.show();
        })
        .always(function () {
          formSubmitted = false;
          $enterpriseSubmit.removeClass("invisible");
        });
    }

    e.preventDefault();
    return false;
  });
});
